import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { loadRuntimeConfig } from './environments/runtime-config';
import { bootstrapApplication } from '@angular/platform-browser';

loadRuntimeConfig()
  .then(async () => {
    if (environment.production) {
      enableProdMode();
    }

    const [{ AppComponent }, { appConfig }] = await Promise.all([
      import('./app/app.component'),
      import('./app/app.config')
    ]);

    return bootstrapApplication(AppComponent, {
      ...appConfig,
      providers: [provideZoneChangeDetection(), ...appConfig.providers]
    });
  })
  .catch(console.error);
